import { PropertyConfig } from "../../../forms/propertyConfig";
import { RegisterValidator, Validator } from "./validator";


export const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
// ! See https://www.regular-expressions.info/email.html
// * This regexp doesn't ensure that the e-mail address is correct, but ensure that it is not too much ill-formed.
// The RFC 5322 norm details how a valid e-mail address should look like. But it is really broad.
// An email is composed of localpart@domainpart
// Local part can be : A sequence of any ASCII characters with escaped white characters, quotes and backslash SURROUNDED by double quotes
// OR a series of letters, digit and certain symbols (!#$%&'*+/=?^_`{|}~-), including one or more dots, but no dots can follow another dot
// directly and the chain cannot end or start with a dot
// Domain part can either be : a fully qualified domain name (ex tachtys-group.com)
// OR a literal Internet address between brackets.
// The current regexp skips the literal Internet address between brackets for domain part (obsolete notation), and the local part notation using double quotes.
// * Only lower case letters are accepted on the two parts.
// To be fully compliant, it should be case-insensitive, but the question of wether
// john.doe@example.org is different from john.Doe@example.org or John.dOe@exAmple.orG is not trivial, especially for the local part which is
// specific to the mail server implementation.
// ! Please note that no check on length of local part and domain part are made, although limitations on length exists within protocols.
// ! The regexp can also let weird sequences like a.'coucou-.~@argh.error pass (no checks on blocks of quotes or brackets are made, nor on rules of the special symbols).

/**
 * This validator ensures the value is an email
 * ! If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
 * sample use in propertyConfig => validators: validatorEntry(EmailValidator, true) or validators: { email: true } (second option requires this class to be loaded)
 */
@RegisterValidator("email")
export class EmailValidator implements Validator<string, boolean> {

    /**
     * Check if property value satisfy email constraint
     */
    public isValid(property: PropertyConfig, propertyValue: string, validatorParams: boolean, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        if (propertyValue == null || propertyValue === "") {
            // If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
            return true;
        }
        // Check length of string first and then check mail address
        // 6 is arbitrary, 254 is max length given https://blog.moonmail.io/what-is-the-maximum-length-of-a-valid-email-address-f712c6c4bc93
        return propertyValue.length <= 254 && propertyValue.length >= 6 ? EMAIL_REGEX.test(propertyValue) : false;
    }
}